<div class="panel" *ngIf="isPanelOpen$ | async">
    <ng-container *ngIf="isCanvasOpen$ | async; else sidebar">
        <!-- In canvas mode one title bar spans the chat and the canvas -->
        <p-ai-chat-window-title-bar
            class="panel-title-bar"
            [isDraggable]="false"
            [isAssistantWorking]="!!(assistantWorking$ | async)"
            [currentLayout]="(layout$ | async)!"
            [canvasAvailable]="frameStore.isOpen()"
            (layoutChange)="setLayout($event)"
        ></p-ai-chat-window-title-bar>
        <div class="panel-canvas-row">
            <p-ai-chat-window class="panel-chat" [showTitleBar]="false" [isDraggable]="false">
                <p-ai-chat-window-content (mousedown)="$event.stopPropagation()"></p-ai-chat-window-content>
            </p-ai-chat-window>
            <div class="panel-canvas-area">
                <p-ai-chat-canvas-frame class="panel-canvas"></p-ai-chat-canvas-frame>
            </div>
        </div>
    </ng-container>

    <ng-template #sidebar>
        <p-ai-chat-window
            class="panel-chat"
            [isDraggable]="false"
            [isAssistantWorking]="!!(assistantWorking$ | async)"
            [currentLayout]="(layout$ | async)!"
            [canvasAvailable]="frameStore.isOpen()"
            (layoutChange)="setLayout($event)"
        >
            <p-ai-chat-window-content (mousedown)="$event.stopPropagation()"></p-ai-chat-window-content>
        </p-ai-chat-window>
    </ng-template>
</div>
